import React from 'react';

export default function LocalAreaGrowthSections({ slug, areaName }) {
  const s = String(slug || '').toLowerCase();
  if (s !== 'plymouth' && s !== 'ipswich') return null;

  return (
    <>
      {s === 'plymouth' && (
        <section className="mt-10" aria-labelledby="plymouth-trades-heading">
          <h2 id="plymouth-trades-heading" className="text-xl font-bold text-gray-900 mb-3">
            Web Design for Plymouth Trades
          </h2>
          <p className="text-gray-700 leading-relaxed">
            From riggers and scaffolders serving yards off the A38 corridor to hospitality and retail on The Barbican and
            events-facing brands above Plymouth Hoe, we write pages that read like Plymouth—not generic national filler. That
            local vocabulary helps Google understand you serve Ocean City and the wider South West, while your visitors see
            coverage, accreditations, and enquiry routes tuned to how trades win work on mobile.
          </p>
        </section>
      )}

      <section className="mt-10" aria-labelledby="construction-specials-heading">
        <h2 id="construction-specials-heading" className="text-xl font-bold text-gray-900 mb-3">
          Scaffolder &amp; Construction Specials
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          No £2,000 upfront fees. Just £19.99/mo for local {areaName} firms who need an affordable website with predictable
          website maintenance, HTTPS, backups-minded hosting, and
          clear scope on published tiers. Larger structural or content campaigns stay quoted separately so your monthly line
          item stays honest.
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>Portfolio-friendly layouts for scaffolding, groundworks, and fit-out crews</li>
          <li>Service-area copy that matches how homeowners search on phones after seeing your van or yard</li>
          <li>Technical SEO baseline so phrases around {areaName} construction and trades have somewhere credible to land</li>
        </ul>
      </section>
    </>
  );
}
